module.exports = __webpack_public_path__ + "img/farm.7b52e8be.png";